<template>
  <div class="Expander__body">
    <div
      v-for="item in match"
      :key="item.id"
      class="match"
      @click="goTodetail(item)"
    >
      <div class="championship">
        <img :src="item.league.logoUrl" v-if="item.league" />
        <p>
          <span class="date">{{ item.eventDate | moment("MM.DD.YY") }}</span>
          <span v-if="item.league">{{ item.league.name }}</span>
        </p>
      </div>
      <div class="table">
        <div>
          <h6>{{ item.firstTeam.name }}</h6>
          <div
            class="team-pic"
            :style="{ backgroundImage: 'url(' + item.firstTeam.logoUrl + ')' }"
          ></div>
        </div>
        <div class="score" v-if="dateCheck(item) == false">
          <p>{{ item.firstTeamScore }}</p>
          <span>:</span>
          <p>{{ item.secondTeamScore }}</p>
        </div>
        <div class="score" v-else>
          <p v-if="item.isTbd == false">{{ item.day }}</p>
          <p v-else>TBD</p>
        </div>
        <div>
          <div
            class="team-pic"
            :style="{ backgroundImage: 'url(' + item.secondTeam.logoUrl + ')' }"
          ></div>
          <h6>{{ item.secondTeam.name }}</h6>
        </div>
      </div>
      <div class="video-column">
        <div class="video-link" v-if="item.video != null">
          <video-btn :btnType="'match'" :videoLink="item.video"></video-btn>
        </div>

        <div class="video-link" v-if="item.streamUrl != null">
          <div>
            <a
              target="_blank"
              :href="item.streamUrl"
              class="btn btn_icon btn-blue"
            >
              <span class="text" v-if="item.time == 'future'"
                >watch the game</span
              >
              <span class="text" v-else-if="item.time == 'past'"
                >full game</span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="match.length == 0">
      <h2>No games:(</h2>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import BtnVideo from "@/components/shared/Video-btn";
export default {
  data() {
    return {
      noGames: false,
    };
  },
  props: {
    matches: Array,
    i: Object,
  },

  computed: {
    match() {
      return this.matches.filter((elem) => {
        var d = moment(elem.eventDate).utc().format("MMM");
        var year = moment(elem.eventDate).utc().format("YYYY");
        if (d === this.i.month && year == this.i.year) {
          return elem;
        } else {
          return false;
        }
      });
    },
  },
  methods: {
    dateCheck(item) {
      var date = item.eventDate;
      if (moment().isAfter(date, "day")) {
        return false;
      } else {
        var data = moment(item.eventDate).utc().format("h : mm A");
        item.day = data;
      }
    },
    goTodetail(matchId) {
      if (
        event.target.tagName == "svg" ||
        event.target.tagName == "path" ||
        event.target.classList.contains("sw-btn") ||
        event.target.parentElement.classList.contains("btn-wrapper") ||
        event.target.parentElement.classList.contains("btn")
      ) {
        return false;
      } else {
        this.$router.push({
          name: "schedule-result",
          params: { id: matchId.id },
        });
      }
    },
  },
  components: {
    "video-btn": BtnVideo,
  },
};
</script>
<style lang="scss" scoped>
.match {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  padding: 1.8rem 2rem 2.1rem 3rem;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 13px 0px;
  }
  @media only screen and (max-width: 1199px) {
    padding: 1.5rem;
  }
  @media only screen and (max-width: 992px) {
    flex-wrap: wrap;
  }
  @media only screen and (max-width: 768px) {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    padding: 3rem 1.5rem;
  }
  &:last-of-type {
    border: none;
  }
}
.table {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 64%;
  @media only screen and (max-width: 992px) {
    //width: 50%;
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
  @media only screen and (max-width: 599px) {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  & > div {
    &:first-of-type {
      width: calc((100% - 13rem) / 2);
      justify-content: flex-end;
    }
    &:last-of-type {
      width: calc((100% - 13rem) / 2);
      justify-content: flex-start;
    }
  }
  img,
  .team-pic {
    height: 5rem;
    width: auto;
    min-width: 5rem;
    margin: 0 2rem;
    @media only screen and (max-width: 1199px) {
      margin: 0 1rem;
    }
    @media only screen and (max-width: 992px) {
      height: 4rem;
    }
    @media only screen and (max-width: 599px) {
      margin-bottom: 1.5rem;
      height: 5rem;
    }
  }
  .team-pic {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  h6 {
    font-size: 1.6rem;
    font-weight: 700;
    text-transform: capitalize;
    @media only screen and (max-width: 992px) {
      //font-size: 1.4rem;
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
    @media only screen and (max-width: 599px) {
      text-align: center;
    }
  }
  div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    &:first-of-type {
      h6 {
        text-align: right;
        @media only screen and (max-width: 599px) {
          text-align: center;
        }
      }
    }
    @media only screen and (max-width: 599px) {
      flex-direction: column-reverse;
      &:last-of-type {
        flex-direction: column;
      }
    }
    &.score {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      min-width: 11rem;
      @media only screen and (max-width: 599px) {
        flex-direction: row;
        margin: 0 1.5rem;
        min-width: 7rem;
      }
      p {
        //min-width: 3.5rem;
        width: 100%;
        text-align: center;
        @media only screen and (max-width: 992px) {
          min-width: 3rem;
        }
        @media only screen and (max-width: 599px) {
          min-width: 2.5rem;
        }
      }
      span {
        display: inline-block;
        margin: 0 1rem;
      }
      p,
      span {
        font-size: 2.6rem;
        font-weight: 700;
        @media only screen and (max-width: 992px) {
          font-size: 1.7rem;
        }
      }
    }
  }
}
.championship {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  //margin-right: 8.5rem;
  min-width: 14.6%;
  @media only screen and (max-width: 992px) {
    min-width: 18%;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
  img {
    width: 3.5rem;
    height: 100%;
    margin-right: 1.8rem;
  }
  p {
    span {
      display: block;
      font-size: 1.3rem;
      line-height: 2rem;
      color: #747474;
      font-weight: 400;
      &.date {
        font-weight: 500;
        line-height: initial;
        color: #363636;
      }
    }
  }
}
.video-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  min-width: 21.4%;
  margin: 0 0 0 auto;
  //margin: 0 0 0 5rem;
  @media only screen and (max-width: 992px) {
    .btn {
      font-size: 1.2rem;
      padding: 0 1.2rem;
      min-width: 20rem;
      span {
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    margin: 2rem auto 0;
  }
}
h2 {
  color: #363636;
  text-align: center;
  max-width: 100%;
  font-size: 1.5rem;
}
</style>